import {
  CGEMetadata,
  CGESimulateRequest,
  CGESimulateResponse,
  CGECommodityTableResponse,
  CGESimulateCommodityRequest,
  CGESimulateCommodityResponse,
  CGETariffEntity,
  CGETariffEntitiesResponse,
  CGECommodityPairRequest,
  CGECommodityRollupPreviewResponse,
} from './_models'

export function getCGEMetadata(axiosPrivate): Promise<{data: CGEMetadata}> {
  return axiosPrivate.get(`/cge/metadata`)
}

export function runCGESimulation(
  axiosPrivate,
  body: CGESimulateRequest
): Promise<{data: CGESimulateResponse}> {
  // Gragg (method: 'gragg') is a non-linear multi-step solve, observed ~15s;
  // bound it generously rather than leaving the request unbounded.
  return axiosPrivate.post(`/cge/simulate`, body, {timeout: 90000})
}

export function getCGECommodityTariffs(
  axiosPrivate,
  params: {reporter: CGETariffEntity; partner: CGETariffEntity; year: number}
): Promise<{data: CGECommodityTableResponse}> {
  return axiosPrivate.get(`/cge/tariff-commodities`, {params})
}

export function runCGECommoditySimulation(
  axiosPrivate,
  body: CGESimulateCommodityRequest
): Promise<{data: CGESimulateCommodityResponse}> {
  return axiosPrivate.post(`/cge/simulate-commodity`, body, {timeout: 90000})
}

export function getCGETariffEntities(axiosPrivate): Promise<{data: CGETariffEntitiesResponse}> {
  return axiosPrivate.get(`/cge/tariff-entities`)
}

export function getCGECommodityRollupPreview(
  axiosPrivate,
  pairs: CGECommodityPairRequest[]
): Promise<{data: CGECommodityRollupPreviewResponse}> {
  return axiosPrivate.post(`/cge/commodity-rollup-preview`, {pairs})
}
